<template>
  <v-container fluid class="list-page" :class="{ 'list-page--embedded': CustomerId }">
    <Create
      :createDialog="createDialog"
      :CustomerId="CustomerId"
      @close="createDialog = false"
      @submit="createCustomerSubmit"
    >
    </Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="editStudentSubmit"
      :editStudent="selectedStudent"
    >
    </Edit>
    <MoveStudent
      :moveStudentDialog="moveStudentDialog"
      @close="moveStudentDialog = false"
      @submit="moveStudentSubmit"
      :student="selectedStudent"
    >
    </MoveStudent>

    <!-- <AssignTeacher @submit="assignSubmit" :Student="selectedStudent" :editDialog="assignClassRoomDialog"
      @close="assignClassRoomDialog = false"></AssignTeacher> -->
    <AssignClassRoom
      @submit="assignClassRoomSubmit"
      :Student="selectedStudent"
      :editDialog="assignClassRoomDialog"
      @close="assignClassRoomDialog = false"
    ></AssignClassRoom>

    <ReportCard
      :Student="selectedStudent"
      :Dialog="reportCardDialog"
      @close="reportCardDialog = false"
    ></ReportCard>

    <AssignClass
      @submit="assignClassSubmit"
      :Student="selectedStudent"
      :editDialog="assignClassDialog"
      @close="assignClassDialog = false"
    ></AssignClass>

    <div v-if="!CustomerId" class="list-page-heading">
      <div>
        <div class="list-page-heading__eyebrow">Community</div>
        <h1>Students</h1>
        <p>Review enrollment, family details, attendance, and fees.</p>
      </div>

      <div class="list-page-heading__actions">
        <v-btn
          v-if="checkRightStatus(9)"
          color="primary"
          depressed
          @click="add"
        >
          <v-icon left>mdi-plus</v-icon>
          New student
        </v-btn>

        <v-btn
          :disabled="count < 1"
          :loading="downloadLoading"
          outlined
          color="primary"
        >
          <download-excel
            :fetch="fetchStudentsForDownload"
            worksheet="Student List"
            :stringifyLongNum="true"
            type="xls"
            :fields="fields"
            name="student"
          >
            <span>
              <v-icon left size="18">mdi-download-outline</v-icon>
              Export
            </span>
          </download-excel>
        </v-btn>
      </div>
    </div>

    <v-row v-if="!CustomerId" class="list-metrics">
      <v-col cols="6" sm="4" md="3">
        <div class="list-metric">
          <div class="list-metric__icon">
            <v-icon color="primary" size="21">mdi-account-school-outline</v-icon>
          </div>
          <div>
            <div class="list-metric__value">{{ count }}</div>
            <div class="list-metric__label">Total students</div>
          </div>
        </div>
      </v-col>

      <v-col cols="6" sm="4" md="3">
        <div class="list-metric">
          <div class="list-metric__icon">
            <v-icon color="primary" size="21">mdi-cash-multiple</v-icon>
          </div>
          <div>
            <div class="list-metric__value">{{ totalFee | currency }}</div>
            <div class="list-metric__label">Fees on this page</div>
          </div>
        </div>
      </v-col>

      <v-col cols="6" sm="4" md="3">
        <div class="list-metric">
          <div class="list-metric__icon">
            <v-icon color="primary" size="21">mdi-calendar-check-outline</v-icon>
          </div>
          <div>
            <div class="list-metric__value">{{ averageAttendance }}%</div>
            <div class="list-metric__label">Average attendance</div>
          </div>
        </div>
      </v-col>

      <v-col cols="6" sm="4" md="3">
        <div class="list-metric">
          <div class="list-metric__icon">
            <v-icon color="primary" size="21">mdi-door-open</v-icon>
          </div>
          <div>
            <div class="list-metric__value">{{ classroomAssignedCount }}</div>
            <div class="list-metric__label">Classroom assigned</div>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-card :loading="loading" class="list-card" elevation="0">
      <div v-if="CustomerId" class="list-card-header">
        <div>
          <div class="list-card-header__title">Students</div>
          <div class="list-card-header__subtitle">
            Students connected to this family
          </div>
        </div>

        <div class="embedded-header-actions">
          <v-chip x-small outlined color="primary">{{ count }}</v-chip>
          <v-btn
            v-if="checkRightStatus(9)"
            small
            color="primary"
            depressed
            @click="add"
          >
            <v-icon left small>mdi-plus</v-icon>
            Add student
          </v-btn>
        </div>
      </div>

      <div class="list-toolbar">
        <v-text-field
          v-model="search"
          class="list-toolbar__search"
          outlined
          prepend-inner-icon="mdi-magnify"
          dense
          background-color="#F8FAF8"
          placeholder="Search by student name, ID, parent, or phone"
          single-line
          hide-details
          clearable
        />

        <div class="list-toolbar__actions">
          <ClassesDropbox
            v-if="!CustomerId"
            class="list-toolbar__control"
            @classSelected="classSelected"
          />

          <v-switch
            v-if="!CustomerId"
            v-model="showLeft"
            class="former-student-switch"
            label="Include former students"
            color="primary"
            inset
            hide-details
          />

          <v-tooltip v-if="!CustomerId" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                outlined
                color="primary"
                @click="openNewTab = !openNewTab"
              >
                <v-icon size="19">
                  {{ openNewTab ? "mdi-open-in-new" : "mdi-open-in-app" }}
                </v-icon>
              </v-btn>
            </template>

            <span>
              {{
                openNewTab
                  ? "Profiles open in a new tab"
                  : "Profiles open in this tab"
              }}
            </span>
          </v-tooltip>
        </div>
      </div>

      <v-data-table
        :server-items-length="count"
        :footer-props="{ 'items-per-page-options': [10, 25, 35, 50] }"
        class="list-table student-table"
        :headers="headers"
        ref="myTable"
        :items="students"
        :search="search"
        :loading="loading"
        :options.sync="options"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <!-- <td class="text-left" :class="{ 'text-decoration-line-through': item.leftDate }">
              <span class="mr-2">{{ item.localId }}</span>

            </td> -->

            <td
              class="text-left"
              :class="{ 'text-decoration-line-through': item.leftDate }"
              @click="viewProfile(tabOpen, item.CustomerId)"
            >
              <div class="student-identity">
                <div class="student-name-line">
                  <span
                    class="student-name text-capitalize"
                    :class="{ 'text-decoration-line-through': item.leftDate }"
                    v-html="$highlight(item.fullName, search)"
                  >{{ item.fullName }}</span>
                  <v-tooltip bottom v-if="item.Customer && item.Customer.payCompassId">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="student-payment-dot" v-bind="attrs" v-on="on" aria-label="Online payment enabled"></span>
                    </template>
                    <span>Set for online payment</span>
                  </v-tooltip>
                </div>
                <div class="student-metadata-row">
                  <span v-if="item.localId !== null && item.localId !== undefined" class="student-local-id">#{{ item.localId }}</span>
                  <span v-if="studentAge(item.dob)" class="student-age">
                    <v-icon size="13">mdi-cake-variant-outline</v-icon>
                    {{ studentAge(item.dob) }}
                    <small>{{ item.dob | moment("M/D/YYYY") }}</small>
                  </span>
                  <span v-else class="student-age student-age--missing">
                    <v-icon size="13">mdi-calendar-blank-outline</v-icon>
                    DOB not provided
                  </span>
                </div>
                <span class="student-since"><v-icon size="14">mdi-calendar-outline</v-icon>Started {{ item.createdAt | moment("MMM D, YYYY") }}</span>
              </div>
              <div>
                <v-chip x-small outlined color="primary" v-if="item.leftDate"
                  >Left {{ item.leftDate | moment("MMM D, YYYY") }}</v-chip
                >
              </div>
            </td>

            <!-- <td>
              <v-tooltip bottom v-if="!item.subscriptionCount">
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar size="10" color="yellow" v-bind="attrs" v-on="on" />
                </template>
                <span>No active subscription</span>
              </v-tooltip>
            </td> -->

            <td
              @click="viewProfile(tabOpen, item.CustomerId)"
              :class="{ 'text-decoration-line-through': item.leftDate }"
              class="text-left"
              v-if="!CustomerId"
            >
              <div class="parent-info" v-if="item.Customer">
                <span class="info-label">Dad</span>
                <div><strong>{{ item.Customer.fatherName || '—' }}</strong><small>{{ item.Customer.fatherPhoneNumber || 'No phone' }}</small></div>
              </div>
              <div class="parent-info" v-if="item.Customer">
                <span class="info-label">Mom</span>
                <div><strong>{{ item.Customer.motherName || '—' }}</strong><small>{{ item.Customer.motherPhoneNumber || 'No phone' }}</small></div>
              </div>
            </td>

            <td
              @click="viewProfile(tabOpen, item.CustomerId)"
              class="text-left"
            >
              <div class="attendance-cell">
              <v-progress-circular
                :size="50"
                :width="5"
                :value="item.per"
                color="primary"
              >
                <span class="attendance-percent">{{ item.per }}%</span>
              </v-progress-circular>
              <div class="attendance-copy"><strong>{{ item.attendedDays || 0 }} of {{ item.attendanceDays || 0 }}</strong><span>days attended</span></div>
              </div>
            </td>

            <!-- <td @click="viewProfile('in', item.CustomerId)" class="text-left"
              :class="{ 'text-decoration-line-through': item.leftDate }">
              {{ item.reference }}
              <div><v-chip x-small dark v-if="item.leftDate">Left On: {{ item.leftDate | moment('MM/DD/YYYY')
                  }}</v-chip>
              </div>
            </td> -->

            <td
              class="text-left"
              :class="{ 'text-decoration-line-through': item.leftDate }"
            >
              <div
                @click="viewProfile(tabOpen, item.CustomerId)"
                v-if="item.ClassStudents.length"
              >
                <div
                  v-for="(classStudents, index) in item.ClassStudents"
                  :key="index"
                >
                  <v-tooltip bottom v-if="classStudents.countInSubscription">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small color="primary" v-bind="attrs" v-on="on"
                        >mdi-check-decagram</v-icon
                      >
                    </template>
                    <span
                      >Once the subscription runs and the invoice is created,
                      this class will be included in the invoice.</span
                    >
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small v-bind="attrs" v-on="on"
                        >mdi-close-thick</v-icon
                      >
                    </template>
                    <span
                      >Despite this class being assigned to the student, they
                      will not be charged when the invoice is created.</span
                    >
                  </v-tooltip>
                  <!-- <v-icon small v-else>mdi-close-thick</v-icon> -->
                  <span
                    ><span
                      v-html="$highlight(classStudents.Class.name, search)"
                      >{{ classStudents.Class.name }}</span
                    >
                    -
                    <span
                      v-html="$highlight(classStudents.parentPay, search)"
                      >{{ classStudents.parentPay | currency }}</span
                    ></span
                  >
                </div>
              </div>
              <div @click="assignClass(item)" v-else>
                  <v-chip small outlined color="primary" class="pointer">
                  Assign department
                </v-chip>
              </div>

              <div>
                <div
                  @click="viewProfile(tabOpen, item.CustomerId)"
                  v-if="item.ClassRoomStudents.length"
                >
                  <div
                    v-for="(classRoom, index) in item.ClassRoomStudents"
                    :key="index"
                  >
                    <div v-if="classRoom.ClassRoom">
                      {{ classRoom.ClassRoom.name }}
                    </div>
                    <div v-else>
                      <v-chip small outlined color="primary">
                        Assign classroom
                      </v-chip>
                    </div>
                  </div>
                </div>
                <div
                  @click="
                    item.ClassStudents.length
                      ? assignClassroom(item)
                      : undefined
                  "
                  v-else
                >
                  <v-chip small outlined color="primary" class="pointer">
                    Assign classroom
                  </v-chip>
                </div>
              </div>
            </td>

            <!-- <td :class="{ 'text-decoration-line-through': item.leftDate }" class="text-left">

            </td> -->

            <td
              :class="{ 'text-decoration-line-through': item.leftDate }"
              class="text-right"
              @click="viewProfile(tabOpen, item.CustomerId)"
            >
              <div class="student-fee">{{ item.totalFee | currency }}</div>
              <div v-if="showBalance === 'show'">
                <div
                  v-if="item.Customer && item.Customer.balance"
                  class="family-balance"
                >
                  {{ item.Customer.balance | currency }}
                </div>
              </div>
            </td>

            <!-- <td :class="{ 'text-decoration-line-through': item.leftDate }" class="text-right"
              @click="viewProfile('in', item.CustomerId)">
              <div v-if="item.Customer && item.Customer.balance" class="red--text font-weight-bold">{{
                item.Customer.balance |
                currency }}</div>
              <div v-else>{{ 0 | currency }}</div>
            </td> -->

            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    v-if="
                      !item.ClassRoomStudents.length &&
                      !item.leftDate &&
                      item.ClassStudents.length
                    "
                    @click="assignClassroom(item)"
                  >
                    <v-list-item-title>Assign Classroom</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!item.leftDate" @click="assignClass(item)">
                    <v-list-item-title>Assign Department</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="!item.leftDate && item.ClassRoomStudents.length"
                    @click="viewReportCard(item)"
                  >
                    <v-list-item-title>View Report Card</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="!item.leftDate || checkRightStatus(11)"
                    @click="editStudent(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-divider v-if="!item.leftDate"></v-divider>
                  <v-list-item v-if="item.leftDate" @click="backStudent(item)">
                    <v-list-item-title>Student Back</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-else @click="leftStudentOpen(item)">
                    <v-list-item-title>Student Left</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="!item.leftDate"
                    @click="moveStudentOpen(item)"
                  >
                    <v-list-item-title>Move Student</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    v-if="checkRightStatus(12)"
                    @click="deleteStudent(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                  <v-divider
                    v-if="item.Customer && item.Customer.balance"
                  ></v-divider>
                  <v-list-item
                    v-if="item.Customer && item.Customer.balance"
                    @click="viewBalanceLetter(item.CustomerId)"
                  >
                    <v-list-item-title
                      >View Pending Bal Letter</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item @click="viewChangeLetter(item.id)">
                    <v-list-item-title
                      >View Fee Change Letter</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <!-- <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert> -->
      </v-data-table>
    </v-card>
    <v-dialog v-model="leftStudentDialog" persistent max-width="520px">
      <v-card class="profile-dialog-card entity-form-dialog">
        <div class="profile-dialog-header entity-form-dialog__header">
          <div class="entity-form-dialog__title">
            <v-avatar size="44" color="green lighten-5">
              <v-icon color="primary">mdi-account-arrow-left-outline</v-icon>
            </v-avatar>
            <div>
              <span>Student roster</span>
              <h2>Mark student as left</h2>
              <p>{{ selectedStudent ? selectedStudent.fullName : "Student" }}</p>
            </div>
          </div>
          <v-btn icon aria-label="Close dialog" @click.stop="leftStudentClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider />
        <v-card-text class="profile-dialog-body entity-form-dialog__body">
          <section class="entity-form-dialog__section">
            <div class="entity-form-dialog__section-heading">
              <span><v-icon size="19" color="primary">mdi-calendar-outline</v-icon></span>
              <div>
                <h3>Last attendance date</h3>
                <p>This date records when the student left the school.</p>
              </div>
            </div>
            <DateSelector :notClearable="true" label="Left date" v-model="leftDate" />
            <div class="entity-form-dialog__summary">
              <v-icon size="18" color="primary">mdi-calendar-sync-outline</v-icon>
              <span>All subscription rows for this student will be removed so future invoices use the updated amount.</span>
            </div>
          </section>
        </v-card-text>
        <v-card-actions class="profile-dialog-actions entity-form-dialog__actions">
          <v-btn text :disabled="leftStudentLoading" @click="leftStudentClose">Cancel</v-btn>
          <v-btn color="primary" depressed :loading="leftStudentLoading" @click="leftStudent">
            <v-icon left small>mdi-account-arrow-left-outline</v-icon>Mark as left
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import studentService from "../service";
import ClassesDropbox from "@/modules/Classes/components/Dropbox.vue";
import DateSelector from "@/components/DateSelector";
import attService from "@/modules/TeacherModules/Attendance/service.js";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
const MoveStudent = () => import("./MoveStudent");
// const AssignTeacher = () =>
//   import("@/modules/Student/components/AssignTeacher.vue");
const AssignClass = () =>
  import("@/modules/Student/components/AssignClass.vue");
const AssignClassRoom = () =>
  import("@/modules/Student/components/AssignClassRoom.vue");
const ReportCard = () => import("@/modules/Student/components/ReportCard.vue");

import Hashids from "hashids";
const hashids = new Hashids();

export default {
  props: {
    showBalance: {
      default: "show",
    },
    CustomerId: {
      default: null,
    },
    ClassId: {
      default: null,
    },
    showAll: {
      default: false,
    },
    // due: {
    //   default: false,
    // },
  },
  name: "student-list",
  data() {
    return {
      debounce: null, // Debounce ke liye add kiya gaya
      openNewTab: true,
      tabOpen: "out",
      count: 0,
      showLeft: false,
      leftStudentDialog: false,
      leftStudentLoading: false,
      moveStudentDialog: false,
      leftDate: this.$moment().toISOString(),
      assignClassRoomDialog: false,
      assignClassDialog: false,
      createDialog: false,
      reportCardDialog: false,
      editDialog: false,
      selectedStudent: null,
      headers: [],
      students: [],
      search: null,
      downloadLoading: false,
      loading: true,
      pageCount: 0,
      selectedClasses: [],
      fields: {
        Date: "date",
        Name: "fullName",
        Father_Name: "Customer.fatherName",
        Father_Contact: "Customer.fatherPhoneNumber",
        Attendance: "attendance",
        Departments: "combinedClassNames",
        ClassRooms: "combinedClassRooms",
        Fee: "totalFee",
      },
      Attendance: [],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["firstName"],
        sortDesc: [false],
      },
    };
  },
  async created() {
    await this.getAttendance();
    await this.getList();
    document.title = "taleem - Student List";

    // this.headers.push({
    //   text: '',
    //   align: "center",
    //   width: '55px',
    //   sortable: false,
    // })
    // this.headers.push({
    //   text: 'Create At',
    //   align: "left",
    //   value: "createdAt",
    //   sortable: true,
    // }
    // );

    this.headers.push(
      {
        text: "Name",
        align: "left",
        value: "firstName",
        sortable: true,
      },
      {
        text: "",
        width: "55px",
        sortable: false,
      }
    );

    if (!this.CustomerId) {
      this.headers.push({
        text: "Parent",
        align: "left",
        value: "Customer.name",
        sortable: false,
      });
    }
    this.headers.push(
      // {
      //   text: "",
      //   value: "",
      //   sortable: false,
      // },

      {
        text: "Department",
        value: "ClassStudents[0].Class.name",
        sortable: false,
      },
      {
        text: "Fee",
        value: "totalFee",
        align: "right",
        sortable: false,
      },
      // {
      //   text: "Outstanding Balance",
      //   value: "Customer.balance",
      //   align: "right",
      //   sortable: true,
      // },
      {
        text: "",
        value: "action",
        sortable: false,
      }
    );
    this.headers = [
      { text: "Student", align: "left", value: "firstName", sortable: true },
      ...(!this.CustomerId ? [{ text: "Parent contacts", align: "left", value: "Customer.name", sortable: false }] : []),
      { text: "Attendance this month", value: "attendance", sortable: false, width: "190px" },
      { text: "Program & classroom", value: "ClassStudents[0].Class.name", sortable: false },
      { text: "Monthly fee", value: "totalFee", align: "right", sortable: false, width: "140px" },
      { text: "", value: "action", sortable: false, width: "60px" },
    ];
    this.$events.listen("studentListEvent", () => this.getList());
  },
  beforeDestroy() {
    this.$events.remove("studentListEvent");
  },
  components: {
    Create,
    Edit,
    MoveStudent,
    AssignClass,
    AssignClassRoom,
    ClassesDropbox,
    DateSelector,
    ReportCard,
    // AssignTeacher,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    studentTitle() {
      return this.count + " Students";
    },
    totalFee() {
      let total = 0;
      this.students.map((row) => {
        total += row.totalFee;
      });
      return total;
    },
    averageAttendance() {
      if (!this.students.length) return 0;

      const total = this.students.reduce((sum, student) => {
        return sum + Number(student.per || 0);
      }, 0);

      return Math.round(total / this.students.length);
    },
    classroomAssignedCount() {
      return this.students.filter((student) => {
        return (
          Array.isArray(student.ClassRoomStudents) &&
          student.ClassRoomStudents.some((row) => row && row.ClassRoom)
        );
      }).length;
    },
  },
  watch: {
    openNewTab(val) {
      if (val) {
        this.tabOpen = "out";
      } else {
        this.tabOpen = "in";
      }
    },
    showLeft() {
      this.getList();
    },
    search() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.options.page = 1;
        this.getList();
      }, 500);
    },
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
  methods: {
    studentAge(dob) {
      if (!dob) return null;
      const birthDate = this.$moment(dob);
      const today = this.$moment();
      if (!birthDate.isValid() || birthDate.isAfter(today, "day")) return null;
      const years = today.diff(birthDate, "years");
      return years < 1 ? "Under 1 year old" : `${years} ${years === 1 ? "year" : "years"} old`;
    },
    fetchStudentsForDownload() {
      this.downloadLoading = true;
      let downloadStudents = this.students;
      downloadStudents.map((row) => {
        row.date = this.$moment(row.createdAt).format("MM/DD/YYYY");
        row.attendance = `${row.per}/100`;
        row.combinedClassNames = row.ClassStudents.map(
          (classStudents) => classStudents.Class?.name
        ) //check if class exists
          .filter((name) => name) // Remove undefined or falsy values
          .join("\n"); // join with line break
        row.combinedClassRooms = row.ClassRoomStudents.map(
          (classRoom) => classRoom.ClassRoom?.name
        )
          .filter((name) => name)
          .join("\n");
      });
      this.downloadLoading = false;
      return downloadStudents;
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const searchValue = search.toLowerCase();

      const checkNested = (obj, searchValue) => {
        for (let key in obj) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            if (checkNested(obj[key], searchValue)) {
              return true;
            }
          } else if (String(obj[key]).toLowerCase().includes(searchValue)) {
            return true;
          }
        }
        return false;
      };

      return checkNested(item, searchValue);
    },
    // customFilter(value, search, item) {
    //   if (!search) return true;
    //   const searchValue = search.toLowerCase();

    //   const fullName = item.fullName ? item.fullName.toLowerCase() : '';
    //   const fatherName = item.Customer && item.Customer.fatherName ? item.Customer.fatherName.toLowerCase() : '';
    //   const fatherPhoneNumber = item.Customer && item.Customer.fatherPhoneNumber ? item.Customer.fatherPhoneNumber.toLowerCase() : '';

    //   return (
    //     fullName.includes(searchValue) ||
    //     fatherName.includes(searchValue) ||
    //     fatherPhoneNumber.includes(searchValue)
    //   );
    // },
    classSelected(val) {
      this.selectedClasses = val;
      this.getList();
    },
    assignClassSubmit() {
      // this.$events.emit("customerProfileEvent");
      this.assignClassDialog = false;
      this.getList();
    },
    assignClassRoomSubmit() {
      this.assignClassRoomDialog = false;
      this.getList();
    },
    editStudentSubmit() {
      // this.$events.emit("customerProfileEvent");
      this.getList();
    },
    moveStudentSubmit() {
      // this.$events.emit("customerProfileEvent");
      this.getList();
    },
    createCustomerSubmit() {
      // this.$events.emit("customerProfileEvent");
      this.getList();
    },
    viewProfile(open, id) {
      if (!this.CustomerId) {
        if (open === "out") {
          let routeData = this.$router.resolve({
            path: `/parents/${id}/profile`,
          });
          window.open(routeData.href, "_blank");
        } else {
          this.$router.push({ path: `/parents/${id}/profile` });
        }
      }

      // this.$router.push({ path: `/parents/${id}/profile` });
    },
    viewReportCard(val) {
      this.selectedStudent = val;
      this.reportCardDialog = true;
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let offset = 0;
      if (itemsPerPage > 0 && page) {
        offset = itemsPerPage * page - itemsPerPage;
      }
      let where = {
        showLeft: this.showLeft,
        filteredClasses: this.selectedClasses,
        limit: itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
        search: this.search,
      };
      if (!this.search || this.search.length <= 3) {
        where.offset = offset;
      }
      if (this.CustomerId) {
        where.CustomerId = this.CustomerId;
      }
      if (this.ClassId) {
        where.ClassId = this.ClassId;
      }

      return studentService.getAll(where).then(async (response) => {
        // console.log('response get all student', response)
        await this.getStudentCount();
        this.loading = false;
        this.students = response.data;
        this.itemsPerPage = this.students.length;
        this.students.map((student) => {
          student.totalFee = 0;
          student.per = 0;
          student.attendedDays = 0;
          student.attendanceDays = 0;
          if (student.ClassStudents.length !== 0) {
            student.ClassStudents.map((row) => {
              student.totalFee += row.parentPay;
            });
          }
        });
        this.setAttendance();
      });
    },
    getStudentCount() {
      let where = {
        showLeft: this.showLeft,
        filteredClasses: this.selectedClasses,
        search: this.search,
      };
      if (this.CustomerId) {
        where.CustomerId = this.CustomerId;
      }
      if (this.ClassId) {
        where.ClassId = this.ClassId;
      }

      return studentService.getStudentCount(where).then((response) => {
        this.count = response.count;
      });
    },
    getAttendance() {
      const where = {
        start: this.$moment().startOf("month").toISOString(),
        end: this.$moment().endOf("month").toISOString(),
      };
      console.log("where", where);
      return attService.attendanceInfo(where).then((response) => {
        // console.log('response attendanceInfo', response)

        this.Attendance = response.data;
      });
    },
    setAttendance() {
      // console.log('return')
      this.Attendance.map(async (row) => {
        row.per =
          ((row.totalPresentAttendance +
            row.totalLateAttendance +
            row.totalLeaveAttendance) /
            row.totalAttendance) *
          100;
        await Promise.all(
          this.students.map((student) => {
            if (student.id === row.id) {
              student.attendedDays = Number(row.totalPresentAttendance || 0) + Number(row.totalLateAttendance || 0) + Number(row.totalLeaveAttendance || 0);
              student.attendanceDays = Number(row.totalAttendance || 0);
              if (isNaN(parseInt(row.per))) {
                student.per = 0;
              } else {
                student.per = parseInt(row.per);
              }
            }
          })
        );
      });
    },
    editStudent(obj) {
      this.selectedStudent = obj;
      this.editDialog = !this.editDialog;
    },
    assignClassroom(obj) {
      this.selectedStudent = obj;
      this.assignClassRoomDialog = !this.assignClassRoomDialog;
    },
    assignClass(obj) {
      this.selectedStudent = obj;
      this.assignClassDialog = !this.assignClassDialog;
    },
    backStudent(student) {
      this.$swal({
        title: "Are you sure?",
        text: `${student.fullName} is back the school.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          studentService
            .update(student.id, {
              leftDate: null,
              markBack: true,
            })
            .then((response) => {
              if (response.data) {
                this.$swal("Back!", "Student was marked Back.", "success");
                this.$events.emit("customerProfileEvent");
                this.getList();
              }
            });
        }
      });
    },
    leftStudentOpen(student) {
      this.leftStudentDialog = true;
      this.selectedStudent = student;
    },
    moveStudentOpen(student) {
      this.moveStudentDialog = true;
      this.selectedStudent = student;
    },
    leftStudent() {
      this.leftStudentLoading = true;
      return studentService
        .update(this.selectedStudent.id, {
          leftDate: this.leftDate,
          markLeft: true,
        })
        .then((response) => {
          if (response.data) {
            this.$swal("Updated", "Student and subscription were updated.", "success");
            this.$events.emit("customerProfileEvent");
            this.$events.emit("subscriptionListEvent");
            this.leftStudentLoading = false;
            this.leftStudentClose();
            return this.getList();
          }
        })
        .finally(() => {
          this.leftStudentLoading = false;
        });
    },
    leftStudentClose() {
      if (this.leftStudentLoading) return;
      this.leftStudentDialog = false;
      this.leftDate = this.$moment().toISOString();
    },
    viewBalanceLetter(id) {
      const hashId = hashids.encode(id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/PendingBalanceLetter`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    viewChangeLetter(id) {
      const hashId = hashids.encode(id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/FeeChangeLetter`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    deleteStudent(student) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove ${student.fullName}.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          studentService.delete(student.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Student has been deleted.", "success");
              this.$events.emit("customerProfileEvent");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
/* Shared page, heading, metrics, card, toolbar, search, and table styles
   come from app.scss. Only student-specific styles remain here. */

.embedded-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.embedded-header-actions .v-btn {
  height: 34px;
  border-radius: 9px;
  text-transform: none;
  letter-spacing: 0;
}

.list-toolbar__actions ::v-deep .v-input--switch {
  margin: 0;
  padding: 0;
}

.list-toolbar__actions ::v-deep .v-label {
  color: #637064;
  font-size: 12px;
}

.student-table ::v-deep tbody tr {
  cursor: pointer;
}

.student-identity {
  display: flex;
  min-width: 190px;
  align-items: flex-start;
  flex-direction: column;
  gap: 4px;
}

.student-name {
  color: #253047;
  font-size: 14px;
  font-weight: 650;
}

.student-name-line {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.student-payment-dot {
  flex: 0 0 9px;
  width: 9px;
  height: 9px;
  border: 1px solid #e0b800;
  border-radius: 50%;
  background: #fdd835;
}

.student-local-id {
  color: #2e7d32;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: .02em;
}

.student-metadata-row {
  display: flex;
  min-width: 0;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 9px;
}

.student-since {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #899489;
  font-size: 10px;
}

.student-age {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #2f6f45;
  font-size: 10px;
  font-weight: 700;
}

.student-age .v-icon {
  color: #2f7d4a;
}

.student-age small {
  margin-left: 1px;
  color: #758578;
  font-size: 9px;
  font-weight: 500;
}

.student-age--missing {
  color: #98a29a;
  font-weight: 500;
}

.student-age--missing .v-icon {
  color: #a8b0aa;
}

.parent-info {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  gap: 7px;
  margin: 3px 0;
}

.parent-info .info-label {
  color: #78907b;
  font-size: 9px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.parent-info div {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.parent-info strong {
  overflow: hidden;
  color: #3c4a40;
  font-size: 11px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.parent-info small {
  color: #899489;
  font-size: 10px;
}

.attendance-cell {
  display: flex;
  min-width: 165px;
  align-items: center;
  gap: 11px;
}

.attendance-percent {
  color: #2e7d32;
  font-size: 10px;
  font-weight: 800;
}

.attendance-copy {
  display: flex;
  flex-direction: column;
}

.attendance-copy strong {
  color: #2e3d31;
  font-size: 13px;
}

.attendance-copy span {
  color: #8a968c;
  font-size: 9px;
}

.student-fee {
  color: #253047;
  font-size: 14px;
  font-weight: 750;
}

.family-balance {
  margin-top: 3px;
  color: #2e7d32;
  font-size: 10px;
  font-weight: 700;
}

@media (max-width: 1100px) {
  .list-toolbar__actions {
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .student-table {
    overflow-x: auto;
  }

  .student-table ::v-deep table {
    min-width: 900px;
  }
}

@media (max-width: 959px) {
  .list-toolbar__actions {
    justify-content: flex-start;
  }
}

@media (max-width: 599px) {
  .embedded-header-actions {
    align-items: flex-end;
    flex-direction: column;
  }
}
</style>
